$.prototype.draggable = function() {
  var t;
  $(this).each(function(i,e) {
    $(e).mousedown(function(e2) {
      e2.preventDefault();
      t = $(e);
      $(e).data({
        down: true,
        x: e2.clientX,
        y: e2.clientY,
        left: $(e).scrollLeft(),
        //top: $(e).scrollTop()
      });
    });
  });
  $(document).mousemove(function(e) {
    if($(t).data("down")) {
      e.preventDefault();
      $(t).scrollLeft($(t).data("x")+$(t).data("left")-e.clientX);
      //$(t).scrollTop($(t).data("y")+$(t).data("top")-e.clientY);
    }
  }).mouseup(function(e) {
    $(t).data("down", false);
  });
};
$(".table_wrap").draggable();

var cxs = document.querySelectorAll('.table_wrap');
cxs = Array.prototype.slice.call(cxs, 0);
cxs.forEach(function(el){
  el.addEventListener("wheel",function(e){
    if (e.deltaX === 0) {
        var reg = 1.5;//スクロール量を変更する場合はここを調整

        el.scrollLeft = el.scrollLeft + e.deltaY*reg;
        
        e.preventDefault();
    }
  });
});

const targetClasses = ['table_wrap', 'scrollbar']

for(const targetClass of targetClasses) {
	document.querySelector(`.${targetClass}`).addEventListener('scroll', function () {
  	const otherClass = this.className.includes(targetClasses[0]) ? targetClasses[1] : targetClasses[0];
    console.log(otherClass)
    const left = document.querySelector(`.${targetClass}`).scrollLeft;
    document.querySelector(`.${otherClass}`).scrollTo(left, 0);
  })
}